<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("role", 2) }}
      </div>
      <router-link class="btn-blue" to="roles"
        >{{ $tc("role", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Roles"
          :key="index"
          class="col-lg-6 col-xl-4"
        >
          <div v-if="item.fieldname !== 'role_id'">
            <div v-if="item.type !== 'radio'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                  />
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has(item.fieldname)">{{
                  errors.first(`${item.fieldname}`)
                }}</span>
              </p>
            </div>
            <div v-if="item.type === 'radio'">
              <div class="d-flex align-items-center min-height-50">
                <label class="mb-0 mr-3">{{ $t(`${item.label}`) }}</label>
                <label class="ios-switch">
                  <input
                    type="checkbox"
                    class="ios-checkbox"
                    v-model="item.fieldvalue"
                  />
                  <span class="switch-slider"></span>
                </label>
              </div>
              <p class="error_message"></p>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="roles">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>

    <div class="white-wrapper">
      <div class="col-md-5 pl-0 mb-4">
        <b-form-input
          v-debounce:300="searchFilterRoles"
          v-model="searchValue"
          placeholder="Search for Module...."
        ></b-form-input>
      </div>
      <div
        v-if="modules.length == 0"
        class="text-center my-5 py-5 section-border"
      >
        <h3 class="mb-0">No Roles Found</h3>
      </div>
      <div v-for="mod in modules" :key="mod.module_category_id" class="mt-3">
        <div
          class="
            section-title section-border
            role-title
            d-flex
            justify-content-between
            align-items-center
          "
          v-b-toggle="`collapse-${mod.module_category_id}`"
        >
          <div class="mb-0">{{ mod.module_name }}</div>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse :id="`collapse-${mod.module_category_id}`">
          <table class="list-view-table mt-2 mb-1">
            <thead>
              <tr>
                <th>Module</th>
                <th>
                  <b-form-checkbox
                    v-if="searchValue.length == 0"
                    class="j-checkbox ml-1"
                    v-model="mod.view"
                    value="Y"
                    unchecked-value="N"
                    @change="selectAllPermissions(mod)"
                    >View</b-form-checkbox
                  >
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(mod1, moduleIndex1) in mod.modules"
                :key="moduleIndex1"
              >
                <td>{{ mod1.module_name }}</td>
                <td>
                  <b-form-checkbox
                    class="j-checkbox"
                    v-model="mod1.view"
                    value="Y"
                    unchecked-value="N"
                    @change="editEditPermission(mod1, 1)"
                    >&nbsp;</b-form-checkbox
                  >
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>
    </div>

  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Roles from "@/helper/formJSONMaster/Roles";
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      btenable: false,
      Roles: Roles.ms_roles,
      modules: [],
      modulesCopy: [],
      ro_id: "",
      selectedModules: [],
      searchValue: "",
      Methods: Roles.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    this.ro_id = id;

    if (id && id != 1) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
    this.getModuleList();
  },
  methods: {
    searchFilterRoles() {
      let filterrolesArray = [];
      if (this.searchValue && this.searchValue.length > 0) {
        this.modulesCopy.forEach((m) => {
          let filteredSubModule = [];

          m.modules.forEach((subm) => {
            if (
              subm.module_name
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            )
              filteredSubModule.push(subm);
          });

          if (filteredSubModule.length)
            filterrolesArray.push({ ...m, modules: filteredSubModule });
        });

        const uniqueModules = _.uniqBy(filterrolesArray, function (e) {
          return e.module_category_id;
        });
        this.modules = uniqueModules;
      } else {
        this.modules = this.modulesCopy;
      }
    },
    getModuleList: function () {
      let loader = this.$loading.show();
      let payload = {
        role_id: this.ro_id,
      };
      UserService.ListAllModules(payload)
        .then((response) => {
          loader.hide();
          const { data } = response;
          if (data.status) {
            data.Records.forEach((m) => {
              if (m.view === true || m.view === false) {
                m.view = m.view === true ? "Y" : "N";
              }
            });
            this.modules = data.Records;
            this.modulesCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getEditList: function (id) {
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Roles.map((x) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onUpdateHandler: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          this.btenable = true;

          let body = this.getRequestBody("PUT", this.Roles, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });

          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/user-management/roles",
                });
                this.btenable = false;
              } else {
                this.btenable = false;
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },

    selectAllPermissions(mod) {
      this.$forceUpdate();
      const [getModule] = this.modules.filter(
        (f) => f.module_category_id == mod.module_category_id
      );
      console.log(getModule, "checkGetModule");
      let mod_id = [];
      let deSelected_mod_id = [];

      if (mod.view === "Y") {
        mod_id = getModule.modules.map((m) => m.module_id);
        getModule.modules.forEach((f) => {
          f.view = "Y";
        });
      } else {
        deSelected_mod_id = getModule.modules.map((m) => m.module_id);
        getModule.modules.forEach((f) => {
          f.view = "N";
        });
      }
      this.$forceUpdate();

      this.addPermission(this.ro_id, 1, mod_id, deSelected_mod_id);
    },

    addPermission(role_id, accessType, mod_id, deSelected_mod_id) {
      let payload = {
        role_id: +role_id,
        module_id: mod_id,
        del_module_id: deSelected_mod_id,
        access_id: accessType,
      };

      UserService.AddPermission(payload).then((res) => {
        this.$toasted.show("Role Permission updated successfully");
      });
    },

    editEditPermission: function (mod, accessType) {
      let mod_ids = [];
      let deSelected_mod_ids = [];
      if (mod.view === "N") {
        deSelected_mod_ids = [mod.module_id];
      } else {
        mod_ids = [mod.module_id];
      }

      let payload = {
        role_id: +this.ro_id,
        module_id: mod_ids,
        del_module_id: deSelected_mod_ids,
        access_id: accessType,
      };

      UserService.AddPermission(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.$toasted.show("User Permission updated successfully");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>
<style>
.role-title {
  cursor: pointer;
  font-size: 18px !important;
  padding: 12px !important;
}
.th-text {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/RolesComponentsOld/editRole.vue